import ViewBase from "../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../framework/tools/scrollview/listview";
import ClubRecordItem from "./club_record_item";

const { ccclass, property } = cc._decorator;

@ccclass
export default class ClubRecordView extends ViewBase {

    @property(cc.Node)
    gerenChoose:cc.Node = null

    @property(cc.Node)
    shouruChoose:cc.Node = null

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    itemPrefab:cc.Node = null

    m_list: ListView = null

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.itemPrefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 1,
            gap_y: 10,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }
    
    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }


    updateShow(m_Data:any = null){
        this.m_list.set_data(m_Data);
        this.m_list.select_item(1)
        this.m_list.scroll_to(0)
    }

    update_list_item(item: cc.Node, data: any, index: number): void {
        let _recordItem = item.getComponent(ClubRecordItem)
        _recordItem.setData(data,index)
    }


    changeBtn(isGren){
        this.gerenChoose.active = isGren
        this.shouruChoose.active = !isGren
    }

}